import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import ClickOutside from './directives/click-outside';
import OnViewport from './directives/on-viewport';
import Truncate from './filters/truncate';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

import './assets/scss/app.scss';

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN_SPA,
  debug: process.env.NODE_ENV === 'development',
  integrations: [new VueIntegration({ Vue, attachProps: true })],
  environment: process.env.VUE_APP_ENV,
});

Vue.directive('click-outside', ClickOutside);
Vue.directive('on-viewport', OnViewport);

Vue.filter('truncate', Truncate);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
